import React from "react";

/**
 * WhileYouWaitChecklist - Reusable checklist box for guidance while waiting for code/email
 * Atomic: Molecule
 */
const CHECKLIST_ITEMS = [
  "Check your Spam/Junk folder",
  "Make sure your inbox isn’t full",
  "Confirm your email address is correct",
  "Add Freedom Mortgage to your safe senders list",
];

export interface WhileYouWaitChecklistProps {
  className?: string;
  style?: React.CSSProperties;
  title?: string;
  items?: string[];
}

export const WhileYouWaitChecklist: React.FC<WhileYouWaitChecklistProps> = ({
  className = "",
  style = {},
  title = "While you wait:",
  items = CHECKLIST_ITEMS,
}) => (
  <div
    style={{
      display: "flex",
      padding: 16,
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 8,
      alignSelf: "stretch",
      borderRadius: 16,
      border: "1px solid var(--Schemes-Outline-Variant, #C4C6CC)",
      marginBottom: 16,
      ...style,
    }}
    className={className}
  >
    <span
      className="text-label-lg text-on-surface-variant font-poppins mb-1"
      style={{
        fontWeight: 400,
        fontSize: 14,
        lineHeight: "20px",
        letterSpacing: "0.1px",
      }}
    >
      {title}
    </span>
    {items.map((text) => (
      <div key={text} style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ display: "flex", alignItems: "center" }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9.5501 17.9996L3.8501 12.2996L5.2751 10.8746L9.5501 15.1496L18.7251 5.97461L20.1501 7.39961L9.5501 17.9996Z" fill="#1B1C1D"/>
          </svg>
        </span>
        <span
          style={{
            color: "var(--Schemes-On-Surface, #1B1C1D)",
            fontFamily: "Poppins, sans-serif",
            fontSize: 12,
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "16px",
            letterSpacing: "0.4px",
          }}
        >
          {text}
        </span>
      </div>
    ))}
  </div>
);
